import React from "react"
import { Link } from "gatsby"

import BannerImg from "../../assets/images/banner-img5.png"

import Shape2 from "../../assets/images/shape/shape2.webp"
import Shape3 from "../../assets/images/shape/shape3.webp"
import Shape5 from "../../assets/images/shape/shape5.webp"
import Shape6 from "../../assets/images/shape/shape6.webp"
import Shape7 from "../../assets/images/shape/shape7.webp"
import Shape13 from "../../assets/images/shape/shape13.webp"
import Shape8 from "../../assets/images/shape/shape8.webp"

const MainBanner = () => {
  const [menu, setMenu] = React.useState(true)

  return (
    <>
      <div className="main-banner">
        <div className="container">
          <div className="banner-area-content">
            <h1
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="100"
            >
              Giải pháp eKYC
            </h1>

            <p
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="200"
            >
              Thị giác máy tính mở ra thế giới của sự nhận biết tự động, nâng cao trải nghiệm số và tạo nên giải pháp thông minh cho mọi ngóc ngách cuộc sống.
            </p>

            <form
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="300"
            >
              <div className="row justify-content-center">
                

                <div className="col-lg-3 col-md-6 col-sm-6">
                  <div className="form-group">
                    <button type="submit" className="white-btn">
                      <Link
                        to="/contact"
                        onClick={(e)=>setMenu(!menu)}
                        className="nav-link"
                      >
                        Liên hệ
                    </Link>
                    </button>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <div className="form-group">
                    <button type="submit" className="default-btn">
                    <Link
                        to="/demo"
                        onClick={(e)=>setMenu(!menu)}
                        className="nav-link"
                      >
                        Dùng thử
                    </Link>
                    </button>
                  </div>
                </div>
              </div>
            </form>

            {/* Main Banner Img */}
            <img 
              src={BannerImg} 
              alt="Banner" 
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="500"
            />
          </div>
        </div>

        {/* Shape Images */}
        <div className="shape2">
          <img src={Shape2} alt="Shape" />
        </div>
        <div className="shape3">
          <img src={Shape3} alt="Shape" />
        </div>
        <div className="shape5">
          <img src={Shape5} alt="Shape" />
        </div>
        <div className="shape6">
          <img src={Shape6} alt="Shape" />
        </div>
        <div className="shape7">
          <img src={Shape7} alt="Shape" />
        </div>
        <div className="shape13">
          <img src={Shape13} alt="Shape" />
        </div>
        <div className="shape8">
          <img src={Shape8} alt="Shape" />
        </div>
      </div>
    </>
  )
}

export default MainBanner
